import { forwardRef } from "react";

import { getArgOrCallback } from "core/args_wrapper";

import { ColumnResizer } from "./ColumnResizer/ColumnResizer";
import HeaderActionCell from "./HeaderActionCell";
import { HeaderAdvancedFilter } from "./HeaderAdvancedFilter/HeaderAdvancedFilter";
import HeaderFilter from "./HeaderFilter";
import { HeaderSort } from "./HeaderSort";

export const HeaderColumn = forwardRef(
	({ clm, isResizing, clmIndex, resizeLeft, preventHandle, mouseDownHandler, storageClmSettings, tableProps: props }, ref) => {
		const clmWidth = storageClmSettings?.width ?? clm.width;
		const minWidth = clm.minWidth;
		const customStyle = clm.headCustomStyle == null ? {} : clm.headCustomStyle;
		const columnWithMinWidth = props.options?.columnsWithMinWidth?.find(({ name }) => name === clm.name);

		return (
			<th
				ref={(el) => (ref.current[clmIndex] = el)}
				clm={clm.name}
				style={{
					textAlign: clm.headHorAlign,
					height: clm.headHeight,
					width: clmWidth,
					maxWidth: clmWidth,
					minWidth: minWidth,
					...customStyle,
				}}
				rowSpan={getArgOrCallback(clm.rowSpan)}
				colSpan={getArgOrCallback(clm.colSpan)}
				className="TableHeadCell"
				data-min-width={columnWithMinWidth ? columnWithMinWidth.minWidth : "0px"}
			>
				{props.options?.newResizableColumns && <ColumnResizer mouseDownHandler={mouseDownHandler} />}
				<div
					className="TableHeadCellContent"
					resizable={String(clm.resize)}
					style={{
						justifyContent: clm.headHorAlign,
						marginLeft: clm.marginLeft,
					}}
				>
					<div className="TableHeadCellTitle" clm={clm.name} title={clm.title}>
						{clm.title}
					</div>

					{clm.sort ? (
						<HeaderSort
							clmName={clm.name}
							tableData={props.tableData}
							sortParams={props.sortParams}
							sortDataUp={props.func.sortDataUp}
							sortDataDown={props.func.sortDataDown}
						/>
					) : (
						<></>
					)}
					{clm.filter ? (
						<HeaderFilter
							clmName={clm.name}
							clmOptions={clm}
							tableData={props.tableData}
							filterParams={props.filterParams}
							filterValues={props?.filterValues}
							updateFilterStatus={props.func.updateFilterStatus}
							filterData={props.func.filterData}
							tableProps={props}
						/>
					) : (
						<></>
					)}
					{clm.advancedFilter && (
						<HeaderAdvancedFilter
							clmName={clm.name}
							advancedSearchParams={props.func.search.advancedSearchParams}
							setAdvancedSearchParams={props.func.search.setAdvancedSearchParams}
						/>
					)}
					{clm.headerAction != null ? <HeaderActionCell clm={clm} tableData={props.tableData} funcs={props.func} /> : <></>}
				</div>
				{isResizing && props.options?.resizableColumns && clmIndex === 0 && (
					<div
						className="ResizePreview"
						style={{ left: `${resizeLeft}px` }}
						onMouseDown={preventHandle}
						onMouseUp={preventHandle}
						onMouseMove={preventHandle}
					></div>
				)}
			</th>
		);
	}
);
